export const locale = {
    lang: 'ds',
    data: {
        'TITLE': {
        },
        'FIELDS': {
            'IsSendEmail': 'Er Send e-mail ?',
            'TabList': 'Fanelisteindstilling',
            'UseNanoLink': 'Bruge Nano Link',
            'NanolinkSetting': 'Nano link settings',
            'SMSSignature': 'SMS signatur',
            'AdditionalMenus': 'Tilføj nye menuer',
            'RedirectingURL': 'Omdirigerer URL',
            'MenuName': 'Menunavn',
            'WorkingStatus': 'Arbejdsstatus',
        },
        'Message': {

        },
        'FILTERS': {
        },
        'moduleTypeList': {
        },
        'BUTTONS': {
            'Save':'Gem',
        },
        'TOOLTIP':{
            'AddMenu': 'Tilføj ny menu',
            'DeleleMenu': 'slet menu'
        }
    }
};